import {productClient, saveClient} from '@/js/helpers/backend-clients';
import {clearSmallInfoMessage, displayAxiosError, displaySmallInfoMessage, hideLoadingOverlay, showLoadingOverlay} from '@/js/helpers/utils';
import router from '@/router';
import context from '@/js/context';

const defaultState = () => {
  let obj = window.sessionStorage.getItem('product_objektart');
  let besi = window.sessionStorage.getItem('product_objektbesichtigung');
  return {
    objektarten: [],
    objektart: obj ? obj : 'EMPTY',
    objektbesichtigungen: [
      {
        text: 'inklusive Besichtigung',
        value: 'BESICHTIGUNG'
      },
      {
        text: 'ohne Besichtigung',
        value: 'KEINE'
      }
    ],
    objektbesichtigung: besi ? besi : 'BESICHTIGUNG',
    kpaPreis: '',
  };
};

const state = defaultState();

const mutations = {
  UPDATE_OBJEKTARTEN(state, obj) {
    state.objektarten = obj;
  },
  UPDATE_OBJEKTART(state, obj) {
    window.sessionStorage.setItem('product_objektart', obj);
    state.objektart = obj;
  },
  UPDATE_OBJEKTBESICHTIGUNG(state, obj) {
    window.sessionStorage.setItem('product_objektbesichtigung', obj);
    state.objektbesichtigung = obj;
  },
  UPDATE_KPA_PREIS(state, obj) {
    state.kpaPreis = obj;
  },
  RESET_STATE(state) {
    Object.assign(state, defaultState());
  },
};

const actions = {
  setMessage({dispatch}, msg) {
    dispatch('setAlert', {message: msg, type: 'info'}, {root: true});
  },
  setObjektbesichtigung({commit}, objektbesichtigung) {
    commit('UPDATE_OBJEKTBESICHTIGUNG', objektbesichtigung);
  },
  setObjektart({commit}, objektart) {
    commit('UPDATE_OBJEKTART', objektart);
  },
  ladeRndObjektarten({commit}) {
    showLoadingOverlay();
    productClient
      .objektarten()
      .then(({data}) => {
        commit('UPDATE_OBJEKTARTEN', data);
      })
      .catch(error => {
        displayAxiosError(error);
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          router.push('/login').finally();
        }
      })
      .finally(() => {
        hideLoadingOverlay();
      });
  },

  ladeKpaPreis({commit}) {
    showLoadingOverlay();
    productClient.kpaPreis()
      .then(({data}) => {
        commit('UPDATE_KPA_PREIS', data);
      })
      .catch(error => {
        displayAxiosError(error);
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          router.push('/login').finally();
        }
      })
      .finally(() => {
        hideLoadingOverlay();
      });
  },

  reset({commit}) {
    window.sessionStorage.removeItem('product_objektart');
    window.sessionStorage.removeItem('product_objektbesichtigung');
    commit('RESET_STATE');
  },

  saveProdukt({dispatch}) {
    const data = dispatch('getData');
    data.then(response => saveClient
      .speichereKonfiguration(response)
      .then(_ => {
          setTimeout(() => {
            displaySmallInfoMessage(
              'Der Auftrag wurde in Ihrem Portalkonto gespeichert.',
            );
          }, 300);
          setTimeout(() => {
            clearSmallInfoMessage()
          }, 3300);
      })
      .catch(error => {
        displayAxiosError(error);
      }), error => displayAxiosError(error));
  },
  getData({rootGetters}) {
    let result;
    switch (state.objektbesichtigung) {
      case context.BESICHTIGUNG:
        result = rootGetters['objektbesichtigung/exportData'];
        break;
      case context.KEINE:
        result = rootGetters['gutachten/exportData'];
        break;
    }
    return {
      allgemeineAngaben: {
        objektart: state.objektart,
        objektbesichtigung: state.objektbesichtigung,
        ...result.allgemeineAngaben
      },
      aussenwaende: {...result.aussenwaende},
      dach: {...result.dach},
      fenster: {...result.fenster},
      fussboeden: {...result.fussboeden},
      innenwaende: {...result.innenwaende},
      decken: {...result.decken},
      sanitaer: {...result.sanitaer},
      heizung: {...result.heizung},
      technischeAusstattung: {...result.technischeAusstattung},
      ansprechpartner: {...result.ansprechpartner},
      alternativeRechnung: {...result.alternativeRechnung},
    };
  },
  saveProduktKpa({dispatch}) {
    const data = dispatch('getDataKpa');
    data.then(response => saveClient
      .speichereKonfigurationKpa(response)
      .then(_ => {
          setTimeout(() => {
            displaySmallInfoMessage(
              'Der Auftrag wurde in Ihrem Portalkonto gespeichert.',
            );
          }, 300);
          setTimeout(() => {
            clearSmallInfoMessage()
          }, 3300);
      })
      .catch(error => {
        displayAxiosError(error);
      }), error => displayAxiosError(error));
  },
  getDataKpa({rootGetters}) {
    return rootGetters['kaufpreisaufteilung/exportData'];
  },
  loadProdukt({dispatch}, {dtype, id}) {
    switch (dtype) {
      case 'kpa':
        dispatch('loadProduktKpa', id);
        break;
      case 'ndgetw':
      case 'ndgmfh':
      case 'ndgefh':
      case 'ndgwgh':
      case 'ndgetwob':
      case 'ndgmfhob':
      case 'ndgefhob':
      case 'ndgwghob':
      case 'ndggkob':
      case 'ndggmob':
      case 'ndgggob':
        dispatch('loadProduktNdg', id);
        break;
      default:
        throw new Error(`Dtype ${dtype} ist unbekannt!`);
    }
  },
  loadProduktNdg({commit, dispatch}, id) {
    saveClient
      .ladeKonfiguration(id)
      .then(data => {
        const allgemeineAngaben = data.data.allgemeineAngaben;
        dispatch('setObjektart', allgemeineAngaben.objektart);
        dispatch('setObjektbesichtigung', allgemeineAngaben.objektbesichtigung);
        dispatch('setWohnungsnummer', allgemeineAngaben.wohnungsnummer);
        return data;
      }).then(saved => {
      switch (state.objektbesichtigung) {
        case context.BESICHTIGUNG:
          dispatch('objektbesichtigung/loadObjektbesichtigung', saved, {root: true});
          break;
        case context.KEINE:
          dispatch('gutachten/loadGutachten', saved, {root: true});
          break;
      }
    });
  },
  loadProduktKpa({commit, dispatch}, id) {
    saveClient
      .ladeKonfigurationKpa(id)
      .then(saved => {
        dispatch('kaufpreisaufteilung/loadKaufpreisauteilung', saved, {root: true});
      });
  },
  deleteProdukt({dispatch}, id) {
    showLoadingOverlay();
    saveClient
      .deleteKonfiguration(id)
      .then(_ => {
        dispatch(
          'gutachtenspeicher/loadPage',
          {
            page: 0,
            pageSize: 20,
            filter: undefined,
          },
          {root: true},
        );
      })
      .catch(error => displayAxiosError(error))
      .finally(() => hideLoadingOverlay());
  },
  duplicateProdukt({dispatch}, id) {
    showLoadingOverlay();
    saveClient
      .duplicateKonfiguration(id)
      .then(_ => {
        dispatch(
          'gutachtenspeicher/loadPage',
          {
            page: 0,
            pageSize: 20,
            filter: undefined,
          },
          {root: true},
        );
      })
      .catch(error => displayAxiosError(error))
      .finally(() => hideLoadingOverlay());
  },
};

const getters = {
  objektarten: () => state.objektarten.filter(art => art.objektbesichtigung === state.objektbesichtigung),
  objektart: () => state.objektart,
  objektbesichtigung: () => state.objektbesichtigung,
  objektbesichtigungen: () => state.objektbesichtigungen,
  kpaPreis: () => state.kpaPreis
};

const productModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default productModule;
